export function hide(element) {
  element.style.setProperty("display", "none");
}

export function show(element) {
  element.style.setProperty("display", "inline-block", "important");
}

export function showBlock(element) {
  element.style.setProperty("display", "block", "important");
}

export function isMobileDevice() {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0
  );
}
